// Feature flag: enable_consolidated_live_models
/**
 * Normalizes portfolio filters by handling the companyOperand logic
 * @param {Array} portfolios - Array of portfolio objects
 * @returns {Array} Normalized portfolio objects
 */
export const normalizePortfolioFilters = portfolios => {
  return portfolios.map(portfolio => {
    const { companyOperand, ...filters } = portfolio.filters;

    if (companyOperand === 'AND') {
      filters.companies_by_and_operator = true;
    }

    return {
      ...portfolio,
      filters,
    };
  });
};
